/* Delea: toggle dell'accordion «Scheda tecnica e riconoscimenti» della scheda
   prodotto. Fino al 2026-09-02 stava inline nella sezione custom_liquid,
   copiato in cinque template; ora e' un asset cacheabile caricato con `defer`
   da snippets/delea-scheda-tecnica.liquid.

   Perche' esiste: <details> si apre da solo, ma gli handler globali di Taiga
   intercettavano il click sul <summary> e lo mangiavano. Il listener sta in
   fase di capture, quindi arriva prima di qualunque handler del tema, e ferma
   la propagazione.

   Perche' e' delegato a document e non agganciato all'elemento: nell'editor
   del tema le sezioni vengono ricaricate, e un listener sull'elemento
   sparirebbe insieme al vecchio DOM. Delegato a document funziona sempre,
   anche con piu' accordion nella stessa pagina. */
(function () {
  function toggle(summary, viaKeyboard) {
    var details = summary.closest('.dl-acc__details');
    if (!details) return;
    var willOpen = !details.open;
    details.open = willOpen;
    summary.setAttribute('aria-expanded', String(willOpen));
    if (viaKeyboard) summary.focus();
  }

  document.addEventListener('click', function (e) {
    var summary = e.target && e.target.closest ? e.target.closest('.dl-acc .dl-acc__summary') : null;
    if (!summary) return;
    e.preventDefault(); /* evita scroll/jump del summary */
    e.stopPropagation(); /* blocca gli handler globali del tema */
    e.stopImmediatePropagation();
    toggle(summary, false);
  }, true);

  /* Accessibilita': Invio e Spazio */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('dl-acc__summary')) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    toggle(t, true);
  }, true);
})();
